<template>
    <div class="page1">
        <div>
            <div class="row1 position-relative" style="height: 180px;" >
                <b-container>
                    <b-row class="info-teach">
                    </b-row>
                </b-container>
            </div>

            <div>
                <div>
                    <b-container>
                        <div class="title-form ">
                            <h5 class="mb-4">Để kết thúc bài kiểm tra, bạn vui lòng trả lời các câu hỏi sau:</h5>
                        </div>
                        <div class="form-info">
                            <b-form @submit.prevent="submitTest">
                                <b-form-group id="input-group-test_speaking_free" label-for="test_speaking_free" >
                                    <h6>Bạn có muốn Test Speaking miễn phí với giáo viên hay không?</h6>
                                    <b-form-select
                                        id="test_speaking_free"
                                        v-model="form.test_speaking_free"
                                        :options="testSpeakingOption"
                                        class="mb-3 form-control"
                                        value-field="value"
                                        text-field="text"
                                    ></b-form-select>
                                </b-form-group>

                                <b-form-group id="input-group-ho_ten_ba_me" label-for="ho_ten_ba_me" >
                                    <b-form-input
                                        id="ho_ten_ba_me"
                                        v-model="form.ho_ten_ba_me"
                                        placeholder="Họ tên Ba/Mẹ"
                                        :required="form.test_speaking_free == 'yes'"
                                        :state="checkStage('ho_ten_ba_me')"
                                        ref="ho_ten_ba_me"
                                    />
                                    <b-form-invalid-feedback :state="checkStage('ho_ten_ba_me')">{{ getErrorMsg("ho_ten_ba_me") }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="input-group-test_date" label-for="test_date" >
                                    <b-form-datepicker
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        locale="vi"
                                        id="test_date"
                                        v-model="form.test_date"
                                        placeholder="Ngày thi speaking dự kiến"
                                        :required="form.test_speaking_free == 'yes'"
                                        :state="checkStage('test_date')"
                                        ref="test_date"
                                    />
                                    <b-form-invalid-feedback :state="checkStage('test_date')">{{ getErrorMsg('test_date') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="input-group-test_time_frame" label-for="test_time_frame" label="Khung giờ có thể tham gia:" v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox-group
                                        id="test_time_frame"
                                        v-model="form.test_time_frame"
                                        :options="timeFrame"
                                        :aria-describedby="ariaDescribedby"
                                        name="test_time_frame"
                                        :state="checkStage('test_time_frame')"
                                        ref="test_time_frame"
                                    ></b-form-checkbox-group>
                                    <b-form-invalid-feedback :state="checkStage('test_time_frame')">{{ getErrorMsg('test_time_frame') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <div class="w-100 text-center">
                                    <b-button @click="submit()" type="submit" variant="success" class="btn-custom btn-next">Next</b-button>
                                    <!-- <b-button @click="form.step = 0" variant="primary">Previous</b-button> -->
                                </div>
                            </b-form>
                        </div>
                    </b-container>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            pageSlug () {
                return this.$route.params.slug
            }
        },
        data () {
            return {
                timeFrame: [
                    '9:00 - 10:30',
                    '10:30 - 12:00',
                    '14:00 - 15:30',
                    '15:30 - 17:00',
                    '17:00 - 18:30',
                    '18:30 - 20:00',
                    '20:00 - 21:30'
                ],
                nextButtonPress: false,
                form: {
                    test_speaking_free: 'yes',
                    test_date: '',
                    test_time_frame: [],
                    ho_ten_ba_me: '',
                },
                testSpeakingOption: [
                    { value: 'yes', text: 'Có' },
                    { value: 'no', text: 'Không' },
                ]
            }
        },
        methods: {
            submitTest (event) {
                event.preventDefault()

                if (
                    this.getErrorMsg('test_date') ||
                    this.getErrorMsg('test_time_frame') ||
                    this.getErrorMsg('ho_ten_ba_me')
                ) {
                    return 
                }
                
                this.$TestApp.pushSurveyForm(this.form)
                .then(() => {
                    this.$TestApp.goToPage(8)
                })
                .catch(error => {
                    this.$bvToast.toast(error.message, {
                        title: `Có lỗi xảy ra !`,
                        variant: 'danger',
                        solid: true
                    })
                })
            },
            
            submit () {
                this.nextButtonPress = true;
            },

            checkPhone(mobile) {
                let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
                if(mobile !==''){
                    if (vnf_regex.test(mobile) == false) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            checkStage(name) {
                if (!this.nextButtonPress) {
                    return null
                }
                
                if (this.form.test_speaking_free == 'yes' && name == 'test_time_frame') {
                    if (this.form.test_time_frame.length == 0) {
                        return false
                    } else {
                        return true
                    }
                }

                const value = this.$refs[name].value ?? ''
                if (
                    this.form.test_speaking_free == 'yes' &&
                    (value.trim() === '' || value.trim() === ' ')
                ) {
                    return false
                }

                if (
                    this.form.test_speaking_free == 'yes' &&
                    (name == 'sdt_ba_me') &&
                    !this.checkPhone(value.trim())
                ) {
                    return false
                }

                return true
                
            },

            getErrorMsg (name) {
                if (!this.nextButtonPress) {
                    return null
                }

                if (name == 'test_time_frame') {
                    if (this.form.test_time_frame.length == 0) {
                        return 'Không được để trống'
                    } else {
                        return ''
                    }
                }
                
                const value = this.$refs[name].value ?? ''
                if (
                    this.form.test_speaking_free == 'yes' &&
                    (value.trim() === '' || value.trim() === ' ')
                ) {
                    return 'Không được để trống'
                }

                if (
                    this.form.test_speaking_free == 'yes' &&
                    (name == 'sdt_ba_me') &&
                    !this.checkPhone(value.trim())
                ) {
                    return 'Số điện thoại không đúng định dạng!' 
                }
            },
        }
    }
</script>
<style >

    .custom-checkbox {
        display: inline-block;
        margin-right: 25px;
        margin-bottom: 10px;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        border: 1px solid;
    }

    .custom-checkbox>input {
        margin-right: 10px;
        width: 15px;
        height: 15px;
    }


    .b-form-datepicker.form-control {
        border-radius: 15px;
        color: #0158a8;
        line-height: 1.5;
        margin-bottom: 20px;
        font-weight: 600;
        box-shadow: 0px 4px 3px #1b96f2;
        height: 50px;
        padding: 5px;
    }

    .b-form-datepicker.form-control .text-muted {
        color: #0158a8 !important;
    }


    .box-tks {
        background-color: #fee138;
        border-radius: 42px;
        color: #0057a7;
        min-height: 400px;
    }

    .box-tks p {
        font-size: 25px;
        text-align: center;
        font-weight: 800;
        text-shadow: 2px 2px #fff,
                     2px -2px #fff,
                    -2px 2px #fff,
                    -2px -2px #fff;
    }

    .check-box span{
        background: #fee138;
        color: #1160a0;
        font-style: italic;
        padding: 5px 15px;
        border-radius: 10px;
        border: 2px solid #1160a0;
        margin-left: 30px;
    }
    .check-box{
        margin-bottom: 40px;
    }
    .check-box input[type="checkbox"]{
        width: 30px;
        height: 25px;
        /* -webkit-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        appearance: none; */
        border: 2px solid #1160a0;
        border-radius: 4px;
        outline: none;
        transition-duration: 0.3s;
        cursor: pointer;
        margin-right: 30px;
        margin-top: -3px;
    }
    .form-box input[type="text"]{
        border: 2px solid #1160a0;
        border-radius: 8px;
    }
</style>


<style scoped>
    .mw-500 {
        max-width: 500px;
    }
    .mw-600 {
        max-width: 640px;
    }
    .background-primary {
        background-color: #87d2fd;
        padding: 20px;
    }

    .page1{
        /* height: 100vh; */
        padding-bottom: 200px;
        position: relative;
    }
    .button-pg1 {
            top: -5px;
    }
    .info-teach{
        display: flex;
        align-items: center;
        width: 65%;
        margin: auto;
        margin-top: 30px;
        position:relative;
    }
    .info-teach span{
        color: #0158a8;
        font-size: 18px;
        font-weight: 700;
        top: -15px;
        position: relative;
    }
    .row1::before{
        content: '';
        position: absolute;
        background-color: #87d2fd;
        width: 100%;
        height: 135px;
        top: 30px;
    }
    .teacher-pg1{
        position: relative;
        top: -35px;
    }
    .form-info{
        width: 45%;
        max-width: 450px;
        margin: auto;
    }
    .title-form h5{
        text-align: center;
        color: white;
        font-weight: 700;
        margin-top: 15px;
    }


    .form-control::-webkit-input-placeholder {
        color: #0158a8;
    }
    .cloudy-pg1{
        position: absolute;
        z-index: 0;
        height: 143px;
        width: 100%;
        bottom: 100px;
    }
    .cloudy-pg1 img{
        width: 100%;
    }
    /* .cloudy-pg1::before{
        content: '';
        position: absolute;
        background-image: url('~@/assets/cloudy.png');
        height: 170px;
        width: 1920px;
        background-size: 100% 100%;
    } */
    .input-group-5{
        display: flex;
        align-items: center;
        border-radius: 15px;
        color: #0158a8;
        margin-bottom: 18px;
        font-weight: 600;
        box-shadow: 0px 4px 3px #1b96f2;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        -webkit-appearance: none;
        -moz-appearance: none;height: 50px;
        padding: 15px;
        appearance: none;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .learn-check{
        margin: 0 35px 0 10px;
    }
    .custom-control {
        height: 20px;
        margin-top: -6px;
        top: 6px;
    }
    .custom-control-input {
        top: 10px;
    }
    .checkbox {
        display:flex;
        flex-direction:column;
        align-items: center;
        margin-left: 40px;
    }

    @media only screen and (max-width: 1200px){
        .form-info {
            width: 50%;
        }
    }

    @media only screen and (max-width: 992px){
        .form-info {
            width: 65%;
        }
    }

    @media only screen and (max-width: 768px){

        .page1{
            height: auto;
        }
        .info-teach{
            width: 100%;
            top: 20px;
        }
        .row1::before {
            top: 15px;
        }
        .info-teach span {
            font-size: 11px;
            top: 0;
        }
        .teacher-pg1 {
            top: 0;
        }
        .form-info {
            width: 100%;
        }
        .learn-check {
            margin: 0 0px 0 10px;
        }
        .checkbox{
            margin-left: 10px;
        }
        .row1 {
            margin-bottom: 45px;
        }
        .title-form h5 {
            font-size: 18px;
        }
        .input-group-5{
            height: auto;
            display: block;
            text-align: center;
            box-shadow: 0px 5px 10px #bac1c5;
            z-index: 9;
            position: relative;
        }
        .learn-check {
            padding-left: 0px;
            display: block;
            margin-bottom: 20px;
        }
        .input-group-5 .checkbox{
            display: inline-block !important;
        }
        .input-group-5 .checkbox:last-child{
            margin-left: 30px;
        }
        .cloudy-pg1{
            bottom: -160px;
        }
        .btn-custom.btn-success{
            font-size: 25px;
        }
    }
    @media only screen and (min-width: 1024px)  and (max-width: 1400px){
        .cloudy-pg1{
            bottom: -220px;
        }
    }
    @media only screen and (min-width: 1024px)  and (max-width: 1200px){
        .info-teach {
            width: 75%;
        }
    }

    @media only screen and (min-width: 1024px)  and (max-width: 1200px){
        .info-teach {
            width: 85%;
        }
    }
    @media only screen and (min-width: 768px)  and (max-width: 1023px){
        .info-teach span{
            font-size: 17px;
        }
        .info-teach {
            width: 100%;
            top: 16px;
        }
        .row1{
            margin-bottom: 10px;
        }
    }
    @media only screen and (min-width: 414px)  and (max-width: 735px){
        .info-teach span {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 1400px){
        .page1>.row1::before {
                top: 12px;
        }
    }
   
   @media only screen and (max-width: 1200px){
        .page1>.row1::before {
                top: 28px;
        }
    }
  
  @media only screen and (max-width: 1024px){
        .page1>.row1::before {
                top: 60px;
        }
    }

    @media only screen and (max-width: 955px){
        .page1>.row1::before {
                top: 45px;
        }
    }

    @media (max-width: 680px){
        form.qanda {
            width: unset;
        }

        form.qanda .custom-radio {
            margin-top: 10px;
        }
    }

    @media only screen and (max-width: 680px){
        .page1>.row1::before {
                top: 40px;
        }
    }

    @media only screen and (max-width: 576px){
        .page1>.row1::before {
                top: 28px;
        }
    }

    @media only screen and (max-width: 576px){
        .page1>.row1::before {
                top: 5px;
        }
    }


</style>